import React from "react";

const MOTIFS = {
  elephant: "https://static.prod-images.emergentagent.com/jobs/9bdd541e-1a44-4e56-8cb5-2c6e284574d7/images/235235e62057406505e239317c81078aa3bc37d391bcd1944b0f8f31a40d2d05.png",
  peacock: "https://static.prod-images.emergentagent.com/jobs/9bdd541e-1a44-4e56-8cb5-2c6e284574d7/images/a0790409cb031c078c07e96c0f09f4dcc7e80f4da7eaa80fa1f2134f7db2c7d1.png",
  tiger: "https://static.prod-images.emergentagent.com/jobs/9bdd541e-1a44-4e56-8cb5-2c6e284574d7/images/0ad85d8b9c4f1a1afba6845e83d86a74e804b411b13d0e78345f11cdc7b229e2.png",
};

// lotus motif renders as inline SVG (no external asset)
const LotusSVG = ({ size, opacity, style, className }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    style={{ opacity, mixBlendMode: "multiply", ...style }}
    className={className}
    aria-hidden="true"
    data-testid="motif-lotus"
  >
    <g fill="none" stroke="#B34A36" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M32 48 C 22 42 16 34 18 26 C 22 30 28 32 32 30 C 36 32 42 30 46 26 C 48 34 42 42 32 48 Z" />
      <path d="M32 30 C 28 22 28 14 32 8 C 36 14 36 22 32 30 Z" />
      <path d="M32 30 C 24 24 18 18 16 12 C 22 14 28 18 32 24" />
      <path d="M32 30 C 40 24 46 18 48 12 C 42 14 36 18 32 24" />
      <path d="M14 48 C 22 50 42 50 50 48" strokeDasharray="2 3" />
    </g>
  </svg>
);

export const Motif = ({ name = "elephant", size = 48, opacity = 0.5, className = "", style = {} }) => {
  if (name === "lotus") {
    return <LotusSVG size={size} opacity={opacity} style={style} className={className} />;
  }
  const url = MOTIFS[name] || MOTIFS.elephant;
  return (
    <img
      src={url}
      alt=""
      aria-hidden="true"
      style={{ width: size, height: size, opacity, mixBlendMode: "multiply", ...style }}
      className={className}
      data-testid={`motif-${name}`}
    />
  );
};

export const MotifDivider = ({ name = "elephant" }) => (
  <div className="divider-motif" data-testid="motif-divider">
    <Motif name={name} size={36} opacity={0.7} />
  </div>
);

export default Motif;
